import type { PropertySection } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { propertyTypeSchema } from './propertyTypeSchema'
import { propertyWithIdSchema } from './propertyWithIdSchema'
import { z } from 'zod'

export const propertySectionSchema = z.object({
  type: z.lazy(() => propertyTypeSchema),
  properties: z.array(z.lazy(() => propertyWithIdSchema)),
  inline: z.boolean().optional(),
  hide_condition: z.string().optional(),
}) as unknown as ToZod<PropertySection>

export type PropertySectionSchema = PropertySection